import { render, staticRenderFns } from "./orderPersDetail.vue?vue&type=template&id=30493de0&scoped=true&"
import script from "./orderPersDetail.vue?vue&type=script&lang=js&"
export * from "./orderPersDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderPersDetail.vue?vue&type=style&index=0&id=30493de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30493de0",
  null
  
)

export default component.exports